import {
  RecommendationStoryState,
  RecommendationKnownAction,
  GET_RECOMMENDATIONS,
  GET_RECOMMENDATIONS_SUCCESS,
  GET_RECOMMENDATIONS_FAIL
} from "./types";
import { Reducer } from "react";

const initialState: RecommendationStoryState = {
  stories: [],
  loading: false,
  error: {
    message: "",
    status: 0,
  },
};

const reducer: Reducer<RecommendationStoryState, RecommendationKnownAction> = (
  state: RecommendationStoryState | undefined = initialState,
  action: RecommendationKnownAction
) => {
  switch (action.type) {
    case GET_RECOMMENDATIONS:
      return {
        ...state,
        loading: true,
      };
    case GET_RECOMMENDATIONS_SUCCESS:
      const filterData = (action.payload || []).filter((story) => {
        return story.fileCount > 0 && story.isProtected === false;
      });
      return {
        ...state,
        loading: false,
        stories: filterData,
      };
    case GET_RECOMMENDATIONS_FAIL:
      return {
        ...state,
        loading: false,
        stories: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export default reducer;
